import CampaignProgram from 'src/features/CampaignProgram';
import { Helmet } from 'react-helmet';
import React from 'react';

const CampaignProgramPage = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Campaign</title>
      </Helmet>
      <CampaignProgram />
    </React.Fragment>
  );
};

export default CampaignProgramPage;
